module.exports = __webpack_public_path__ + "img/spaceship.872c2040.svg";